export default {
  accepted: 'Accepted',
  accessRequestDate: 'Access request date',
  confirmUserWillBeSystemAdmin: 'User will be a system administrator. Continue?',
  copyInvitationLink: 'Copy invitation link to clipboard',
  copyInvitationLinkConfirmMessage: `If the invited user hasn't received any emails at the address {{email}},
you can copy the invitation link to the clipboard and share it with him in other ways.

Copy the invitation link to the clipboard?`,
  copyPasswordResetLink: 'Copy reset password link to clipboard?',
  copyPasswordResetLinkConfirmMessage: `If the user has reset his password but he hasn't received any emails at the address {{email}},
you can copy the reset password link to the clipboard and share it with him in other ways.

Copy the reset password link to the clipboard?`,
  editSurveyUserExtraPropsForUser: 'Edit survey user extra properties for user "{{userName}}"',
  inviteUser: 'Invite',
  invitationExpiredClickToSendAgainTheInvitation: 'Invitation expired: click to send again the invitation',
  invitationLinkCopiedToClipboard: 'Invitation link copied to your clipboard',
  invitedBy: 'Invited by',
  invitedDate: 'Invited date',
  lastLogin: 'Last login',
  moreThan30DaysAgo: 'More than 30 days ago',
  notAcceptedYet: 'Invitation not accepted yet',
  passwordResetLinkCopiedToClipboard: 'Password reset link copied to your clipboard',
  passwordResetLink: 'Password reset link',
  prefs: {
    title: 'Notification preferences',
    notifyOnUserAccessRequest: 'New user access requests',
  },
  roleInCurrentSurvey: 'Role in current survey',
  roleInSurvey: 'Role in survey',
  filterPlaceholder: 'Filter by name or email',
  surveyName: 'Survey name',
  surveyExtraProp: {
    label: 'Survey extra property',
    label_other: 'Survey extra properties',
  },
  surveysDraft: 'Surveys (draft)',
  surveysPublished: 'Surveys (published)',
  userRemovedFromSurveyGoToSurveysRequired: `You have been removed from this survey.  
Press Go to surveys to open the surveys list.`,
  userRoleUpdatedRefreshRequired: `Your role in this survey has been updated.  
$t(common.pressRefreshToReloadPage)`,
  userGroup: {
    new: 'New Group',
    edit: 'Edit Group',
    name: 'Name',
    label: 'Label',
    qualifier: 'Qualifier {{index}}',
    qualifier_other: 'Qualifiers',
    qualifierKey: 'Key',
    qualifierValue: 'Value',
    addQualifier: 'Add qualifier',
    members: 'Members',
    addMember: 'Add member',
    noMembers: 'No members yet',
    memberAlreadyInGroup: 'Currently in "{{groupName}}"',
    tabs: {
      groups: 'User Groups',
      assignments: 'Group Assignments',
      report: 'Members Report',
    },
    memberName: 'Member Name',
    memberEmail: 'Member Email',
    memberRole: 'Survey Role',
    memberStatus: 'Status',
    status: {
      INVITED: 'Invited',
      ACCEPTED: 'Accepted',
      FORCE_CHANGE_PASSWORD: 'Password change required',
    },
    unassigned: 'Unassigned',
    confirmDelete: 'Delete group "{{name}}"? Its members will become unassigned. Continue?',
    deleteConfirmed: 'Group "{{name}}" has been deleted',
    saveConfirmed: 'Group "{{name}}" has been saved',
    confirmReassign: '{{userName}} is currently in group "{{groupName}}". Move them to this group instead?',
    notFound: 'Group not found',
    readableGroups: 'Can view the records of',
    readableGroupsInfo:
      'Members of this group can view, export and download (also in Arena Mobile) the records of the selected groups, but cannot edit them',
  },
  updateUserConfirmation: 'User {{name}} has been updated',
  userNotInvitedToAnySurvey: `User not invited to any survey`,
  userSurveys: 'User Surveys',
  usersBackup: {
    menu: 'Backup / Restore',
    backup: 'Backup users',
    backupTitle: 'Backup users',
    backupInfo:
      'All users will be exported with their survey roles and user groups, so that they can be restored into another Arena server. 2FA devices are not exported.',
    includePasswords: 'Include passwords',
    passwordsWarning:
      'The backup file will contain the password hashes: keep it in a safe place and delete it after use.',
    restore: 'Restore users',
    restoreTitle: 'Restore users from backup',
    restoreInfo: `- Users are matched by email
- Survey roles and user groups are matched by survey name and group name
- Roles and user groups of surveys not existing in this server are ignored
- After pressing "Restore users", you can choose what to do with every user`,
    backupFileInfo: 'Backup generated by {{email}} on {{date}} (server: {{serverUrl}})',
    passwordsNotIncluded: 'Passwords are not included in this backup: new users will have to reset their password',
    allNewUsers: 'All new users ({{count}})',
    allExistingUsers: 'All existing users ({{count}})',
    userStatus: 'Status',
    userActionHeader: 'Action',
    userNew: 'New',
    userExisting: 'Existing',
    userAction: {
      insert: 'Add',
      skip: 'Skip',
      updateRoles: 'Update survey roles',
      updateAll: 'Update survey roles and details',
    },
    sysAdmin: 'Sys. admin',
    restorePassword: 'Password',
    restorePasswordInfo:
      'Restore the password stored in the backup (only when adding the user or updating its details)',
    userActionShort: {
      insert: 'Add',
      skip: 'Skip',
      updateRoles: 'Roles',
      updateAll: 'Roles + details',
    },
    details: {
      survey: 'Survey',
      roleInBackup: 'Role in backup',
      currentRole: 'Current role',
      notFoundInThisServer: '(not found in this server)',
      userGroup: 'User group',
      inBackup: 'In backup',
      currentMember: 'Current member',
    },
    summaryImported: 'Users restored',
    summary: {
      usersTotal: 'Users in backup: {{count}}',
      usersInserted: 'New users: {{count}}',
      usersUpdated: 'Updated users: {{count}}',
      usersSkipped: 'Skipped users: {{count}}',
      authGroupsAdded: 'Survey roles added: {{count}}',
      userGroupsAdded: 'User group memberships added: {{count}}',
    },
    surveysNotFound: 'Surveys not found (roles ignored): {{names}}',
    userGroupsNotFound: 'User groups not found (memberships ignored): {{names}}',
  },
}
